import { AdjustColorTint, colors, HexToRgba } from 'utils/colors'

const genBgImg = (colorHash: string) =>
  `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='100' ry='100' stroke='%23${colorHash.substring(
    1,
  )}' stroke-width='2' stroke-dasharray='3%2c 3%2c 4' stroke-dashoffset='73' stroke-linecap='round'/%3e%3c/svg%3e")`

const darkerGray = AdjustColorTint(colors.gray5, -10)
const lightGray = HexToRgba(colors.gray5, 0.16)
const lightGreen3 = AdjustColorTint(colors.green3, 10)
const lightGreen3V2 = HexToRgba(colors.green3, 0.1)
const lightGrayBorder = HexToRgba(colors.gray5, 0.24)

/**
 * dashed circle gray button styles
 */
export const dashedCircleGray = {
  bg: 'transparent',
  border: 'none',
  backgroundImage: genBgImg(colors.gray4),
  borderRadius: '100px',
  '& > svg': {
    color: 'gray5',
  },

  // Hover style
  '&:hover': {
    bg: 'gray2',
    backgroundImage: genBgImg(colors.gray5),

    '& > svg': {
      color: 'gray5',
    },
  },

  // Active Focus style
  '&active': {
    backgroundImage: genBgImg(colors.blue1),

    '& > svg': {
      color: 'blue1',
    },
  },

  // Disabled style
  '&:disabled': {
    backgroundImage: genBgImg(colors.gray4),

    '& > svg': {
      color: 'gray4',
    },
  },
}

/**
 * dashed circle blue button styles
 */
export const dashedCircleBlue = {
  bg: 'transparent',
  border: 'none',
  backgroundImage: genBgImg(colors.blue1),
  borderRadius: '100px',
  '& > svg': {
    color: 'blue1',
  },
}

/**
 *  xButtonRed
 */

export const xButtonRed = {
  border: '1px solid',
  borderColor: 'gray4',
  borderRadius: '4px',
  '& > svg': {
    color: 'blue1',
  },

  // Hover style
  '&:hover': {
    borderColor: darkerGray,
  },

  // Disabled style
  '&:disabled': {
    bg: lightGray,
    borderColor: lightGrayBorder,

    '& > svg': {
      color: 'gray5',
      opacity: 0.5,
    },
  },
}

/**
 *  checkButtonGreen
 */

export const checkButtonGreen = {
  bg: 'green3',
  border: '1px solid',
  borderColor: 'green3',
  borderRadius: '4px',
  '& > svg': {
    color: 'white',
    margin: 0,
  },

  // Hover style
  '&:hover': {
    bg: lightGreen3,
    borderColor: lightGreen3,
  },

  // Disabled style
  '&:disabled': {
    bg: lightGray,
    borderColor: lightGrayBorder,

    '& > svg': {
      color: 'gray5',
      opacity: 0.5,
    },
  },
}

export const xButtonRedV2 = {
  ...xButtonRed,
  bg: HexToRgba(colors.red, 0.1),
  borderColor: 'red',
  '&:hover': {
    bg: HexToRgba(colors.red, 0.2),
  },
}

export const checkButtonGreenV2 = {
  ...checkButtonGreen,
  bg: lightGreen3V2,
  '&:hover': {
    bg: HexToRgba(colors.green3, 0.2),
  },
}
